import { LEFT_WIDTH, TIMELINE_HEADER_HEIGHT } from "../../core/layoutConstants";
import { getTrackGap, getTrackHeight } from "../../core/functions";
import { ForwardedRef, forwardRef } from "react";
import { TrackWithOrder } from "@opstel/SBD/core/occupations";
import { TrackGroup } from "@opstel/query/models/trackGroup";

interface SBDCenterLeftProps {
  readonly tracks: TrackWithOrder[];
  readonly trackGroups: TrackGroup[];
}

function SBDCenterLeftWithRef(props: SBDCenterLeftProps, ref: ForwardedRef<HTMLDivElement>) {
  const { tracks, trackGroups } = props;

  return (
    <div
      className="order-1 h-full overflow-hidden"
      style={{ paddingTop: `${TIMELINE_HEADER_HEIGHT}px`, width: `${LEFT_WIDTH}px` }}
    >
      <div
        ref={ref}
        className="order-1 flex h-full flex-col overflow-hidden pl-6 *:first:mt-6 *:last:mb-6"
        style={{
          gap: getTrackGap().toString(),
          width: `${LEFT_WIDTH}px`,
        }}
      >
        {tracks.map(({ name, maxOrder, code }) => {
          const trackGroup = trackGroups.find((trackGroup) =>
            trackGroup.tracks.some((track) => track.code === code),
          );
          return (
            <h4
              key={code}
              className="m-0"
              style={{ height: getTrackHeight(maxOrder), minHeight: getTrackHeight(maxOrder) }}
              title={trackGroup ? `Spoorgroep: ${trackGroup.name}` : ""}
            >
              {name}
            </h4>
          );
        })}
      </div>
    </div>
  );
}

export const SBDCenterLeft = forwardRef<HTMLDivElement, SBDCenterLeftProps>(SBDCenterLeftWithRef);
